// React
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Redux
import { useDispatch } from "react-redux";
import { openSnackbar } from "Store/SnackbarSlice";

// Auth
import { signOut } from "aws-amplify/auth";
import { clearAppSessionStorage } from "Auth/authUtils";

// Components
import { Toolbar, Typography, Stack, AppBar } from "@mui/material";
import { AvatarMenu } from "Common/Components";

// Styles
import { styles } from "./styles";

const NavigationBar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleMenuClick = (event) => {
    anchorEl !== event.currentTarget && setAnchorEl(event.currentTarget);
  };

  const handleGoHome = () => {
    navigate("/");
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      clearAppSessionStorage();
      window.location.reload();
    } catch (error) {
      dispatch(openSnackbar({ message: error.message, severity: "error" }));
    }
  };

  return (
    <AppBar position="fixed">
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography
            variant="h6"
            noWrap
            onClick={handleGoHome}
            sx={styles.title}
          >
            Admin Portal
          </Typography>
        </Stack>
        <AvatarMenu
          anchorEl={anchorEl}
          handleMenuClick={handleMenuClick}
          handleMenuClose={() => setAnchorEl(null)}
          handleSignOut={handleSignOut}
        />
      </Toolbar>
    </AppBar>
  );
};

export default NavigationBar;
